<template>
  <nav
    :class="$style.root"
  >
    <div :class="$style.content">
      <i18n-link
        :to="{ name: 'publications', query: { ...resetQuery } }"
        :class="$style.item"
        :data-current="!categoryId?.length ? '' : null"
      >
        {{ $t('shared.all') }}
      </i18n-link>

      <i18n-link
        v-for="(item, index) in data"
        :key="index"
        :to="{ name: 'publications', query: { ...query, categoryId: item?.id } }"
        :class="$style.item"
        :data-current="categoryId === String(item?.id) ? '' : null"
      >
        {{ item?.title }}
      </i18n-link>
    </div>
  </nav>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  data: {
    type: Array,
    default: true
  }
})

const query = computed(() => route?.query)
const resetQuery = computed(() => useOmit(route?.query, ['categoryId']))
const categoryId = computed(() =>  route?.query?.categoryId)
</script>

<style module>
.root {
  composes: font-size-small container from global;
  user-select: none;
}

.content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--stroke--default);
}

.item {
  composes: reset-link button-rectangular from global;
  display: block;
}
</style>
